let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("c1m3a")).then(() => parcelRequire('l4qlp'));